export function getTinyImage(image) {
  return image && image.url
    ? image.thumbnails &&
      image.thumbnails.small &&
      image.thumbnails.small.dimensions
      ? {
          width: image.thumbnails.small.dimensions.width / 2,
          height: image.thumbnails.small.dimensions.height / 2,
          url: image.thumbnails.small.url,
          alt: image.thumbnails.small.alt || image.alt,
        }
      : image.thumbnails.medium && image.thumbnails.medium.dimensions
      ? {
          width: image.thumbnails.medium.dimensions.width / 2,
          height: image.thumbnails.medium.dimensions.height / 2,
          url: image.thumbnails.medium.url,
          alt: image.thumbnails.medium.alt || image.alt,
        }
      : image.thumbnails.large && image.thumbnails.large.dimensions
      ? {
          width: image.thumbnails.large.dimensions.width / 2,
          height: image.thumbnails.large.dimensions.height / 2,
          url: image.thumbnails.large.url,
          alt: image.thumbnails.large.alt || image.alt,
        }
      : {
          width: image.dimensions.width / 2,
          height: image.dimensions.height / 2,
          url: image.url,
          alt: image.alt || image.alt,
        }
    : '';
}

export function getSmallImage(image) {
  return image && image.url
    ? image.thumbnails &&
      image.thumbnails.small &&
      image.thumbnails.small.dimensions
      ? {
          width: image.thumbnails.small.dimensions.width / 2,
          height: image.thumbnails.small.dimensions.height / 2,
          url: image.thumbnails.small.url,
          alt: image.thumbnails.small.alt || image.alt,
        }
      : image.thumbnails.medium && image.thumbnails.medium.dimensions
      ? {
          width: image.thumbnails.medium.dimensions.width / 2,
          height: image.thumbnails.medium.dimensions.height / 2,
          url: image.thumbnails.medium.url,
          alt: image.thumbnails.medium.alt || image.alt,
        }
      : image.thumbnails.large && image.thumbnails.large.dimensions
      ? {
          width: image.thumbnails.large.dimensions.width / 2,
          height: image.thumbnails.large.dimensions.height / 2,
          url: image.thumbnails.large.url,
          alt: image.thumbnails.large.alt || image.alt,
        }
      : {
          width: image.dimensions.width / 2,
          height: image.dimensions.height / 2,
          url: image.url,
          alt: image.alt || image.alt,
        }
    : '';
}

export function getMediumImage(image) {
  return image && image.url
    ? image.thumbnails &&
      image.thumbnails.medium &&
      image.thumbnails.medium.dimensions
      ? {
          width: image.thumbnails.medium.dimensions.width / 2,
          height: image.thumbnails.medium.dimensions.height / 2,
          url: image.thumbnails.medium.url,
          alt: image.thumbnails.medium.alt || image.alt,
        }
      : image.thumbnails.large && image.thumbnails.large.dimensions
      ? {
          width: image.thumbnails.large.dimensions.width / 2,
          height: image.thumbnails.large.dimensions.height / 2,
          url: image.thumbnails.large.url,
          alt: image.thumbnails.large.alt || image.alt,
        }
      : {
          width: image.dimensions.width / 2,
          height: image.dimensions.height / 2,
          url: image.url,
          alt: image.alt || image.alt,
        }
    : '';
}

export function getLargeImage(image) {
  return image && image.url
    ? image.thumbnails &&
      image.thumbnails.large &&
      image.thumbnails.large.dimensions
      ? {
          width: image.thumbnails.large.dimensions.width / 2,
          height: image.thumbnails.large.dimensions.height / 2,
          url: image.thumbnails.large.url,
          alt: image.thumbnails.large.alt || image.alt,
        }
      : {
          width: image.dimensions.width / 2,
          height: image.dimensions.height / 2,
          url: image.url,
          alt: image.alt || image.alt,
        }
    : '';
}

export function getOriginalImage(image) {
  return (
    image &&
    image.url && {
      width: image.dimensions.width / 2,
      height: image.dimensions.height / 2,
      url: image.url,
      alt: image.alt || image.alt,
    }
  );
}

export function clientTitle(client) {
  const name = client && client.client_name ? client.client_name : null;
  const alias = client && client.client_alias ? client.client_alias : null;
  return name ? name.concat('AKA ' + alias) : alias ? alias : null;
}
